import { Modal } from '@mairistem/composants';
import React from 'react';
import type OutilModalProps from '../../../../interfaces/simulation/outilModalProps';
import ImportExportExcelMenu from './ImportExportExcelMenu';

const ImportExportExcelModal = ({
	onClose,
	onValidate,
	open,
	simulation,
}: OutilModalProps) => {
	const handleClose = () => onClose?.();

	return (
		<Modal closeIcon onClose={handleClose} open={open}>
			<Modal.Header content="Exporter / Importer au format Excel" />
			<Modal.Content>
				<ImportExportExcelMenu
					onValidate={onValidate}
					simulation={simulation}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ImportExportExcelModal;
